import type { BlindKingsGame } from '@blind-kings/game-core';

/** Seat that is about to act (0 or 1). */
export function actingSeat(game: BlindKingsGame): 0 | 1 {
  return (game.turnIndex % 2) as 0 | 1;
}

export function rivalSeat(me: 0 | 1): 0 | 1 {
  return me === 0 ? 1 : 0;
}

/**
 * Whether `lastActionPlayer` awards seat `me` under game-core’s inverted index:
 * index 1 ⇒ first seat acted; index 0 ⇒ second seat acted.
 */
export function lastActionWasSeat(game: BlindKingsGame, me: 0 | 1): boolean {
  const idx = Number(game.lastActionPlayerIndex ?? 0);
  const firstActed = idx !== 0;
  return me === 0 ? firstActed : !firstActed;
}

/**
 * After seat `actor` acts, store the *next* turnIndex so `lastActionPlayer` resolves
 * correctly (see win-conditions tests).
 */
export function lastActionPlayerIndexAfter(actor: 0 | 1): 0 | 1 {
  return actor === 0 ? 1 : 0;
}
